import { BlankView } from "@/components";
import { constantsData } from "@/data";

export const ErrorModeBlankView = ({ error } : { error?: Error }) => (
    <BlankView
        description={constantsData.msgs.somethingWrong}
        actionBtnData={{
            onClick: () => window.location.reload(),
            text: constantsData.buttons.refresh,
        }}
        otherData={(
            <pre className="overflow-x-auto rounded border border-gray-300 bg-neutral-900 p-2 text-foreground shadow-custom dark:bg-primary md:p-4">
                <code className="font-mono text-xs text-gray-100 md:text-sm">
                    {error?.message ? (
                        <div className="flex flex-col gap-3 md:gap-6">
                            <div className="flex flex-col gap-2">
                                <span className="text-danger">
                                    {"// "}
                                    {constantsData.labels.errorMessage}
                                    :
                                </span>
                                <span>{error.message}</span>
                            </div>
                            {error.stack ? (
                                <div className="flex flex-col gap-2">
                                    <span className="text-danger">
                                        {"// "}
                                        {constantsData.labels.stack}
                                    </span>
                                    <span>{error.stack}</span>
                                </div>
                            ) : null}
                        </div>
                    ) : (
                        <span className="text-danger">
                            {"// "}
                            {constantsData.msgs.unexpectedErrorOccurred}
                        </span>
                    )}
                </code>
            </pre>
        )}
        hasActionBtn
        hasDescription
    />
);
